@let showEndedTeams = (showEndedTeams$ | async) ?? false;

<adapt-render-organisation-map [teamTemplate]="teamTemplate"
                               [globalZoneLocationTemplate]="globalZoneLocationTemplate"
                               [showGlobalZoneLocation]="isEditing || (showGlobalZone$ | async)"
                               globalZoneLocationLabel="Global Groups"
                               [filterTeams]="filterTeams"
                               [isEditing]="isEditing"
                               (loaded)="loaded.emit()"></adapt-render-organisation-map>

<ng-template #teamContentTemplate
             let-team
             let-level="level">
    @if (supplementaryDataVisible.length > 0) {
        <div class="d-flex flex-column team-supplementary-data">
            @if (supplementaryDataVisible.includes(OrganisationMapSupplementaryData.TeamMembers)) {
                @if (level >= 3 || teamMemberCount(team) > 0) {
                    <!-- icon in adapt-link-team above and adapt-link-role below all have left margin of 0.25rem. So make this ms-1
                     instead of the previous ms-2 for adapt-team-membership and add -ve margin to first leader item to align
                     - now can remove the -ve margin from first leader and multiple rows of team members will align properly -->
                    <adapt-team-membership [team]="team"
                                           class="ms-1 mt-2"
                                           imageSize="sm"
                                           [showPopover]="false"></adapt-team-membership>
                }
            }
            <div class="team-roles-systems">
                @if (supplementaryDataVisible.includes(OrganisationMapSupplementaryData.Systems)) {
                    @if (getTeamSystems(team) | async; as systems) {
                        @if (systems.length > 0) {
                            <adapt-see-more class="mt-1"
                                            [stopPropagation]="true"
                                            [maxHeight]="130"
                                            [scrollIntoViewOnToggle]="false"
                                            gradient>
                                <div class="d-flex flex-column gap-1">
                                    @if (supplementaryDataVisible.includes(OrganisationMapSupplementaryData.Roles)) {
                                        <h5 class="m-0 ms-1">Systems</h5>
                                    }
                                    @for (system of systems; track system.systemEntityId) {
                                        <adapt-link-system [system]="system"></adapt-link-system>
                                    }
                                </div>
                            </adapt-see-more>
                        }
                    }
                }
                @if (supplementaryDataVisible.includes(OrganisationMapSupplementaryData.Roles)) {
                    @if (getTeamRoleLocations(team) | async; as teamRoleLocations) {
                        @if (teamRoleLocations.length > 0) {
                            <adapt-see-more class="mt-1"
                                            [stopPropagation]="true"
                                            [maxHeight]="130"
                                            [scrollIntoViewOnToggle]="false"
                                            gradient>
                                <div class="d-flex flex-column gap-1">
                                    @if (supplementaryDataVisible.includes(OrganisationMapSupplementaryData.Systems)) {
                                        <h5 class="m-0 ms-1">Roles</h5>
                                    }
                                    @for (teamRoleLocation of teamRoleLocations; track teamRoleLocation.roleId) {
                                        @if (teamRoleLocation.role) {
                                            <adapt-link-role [role]="teamRoleLocation.role"
                                                             [showIcon]="true"></adapt-link-role>
                                        }
                                    }
                                </div>
                            </adapt-see-more>
                        }
                    }
                }
            </div>
            @if (supplementaryDataVisible.includes(OrganisationMapSupplementaryData.Accountabilities)) {
                @if (supplementaryDataPrime$ | async) {
                    @if (team.supplementaryData?.accountabilities) {
                        <div class="p-1 mx-1 mt-2 accountabilities">
                            <h5 class="m-0 mb-1">Accountabilities</h5>
                            <adapt-see-more class="see-more-accountabilities"
                                            [stopPropagation]="true"
                                            [maxHeight]="130"
                                            [scrollIntoViewOnToggle]="false"
                                            gradient>
                                <div [froalaView]="team.supplementaryData.accountabilities"></div>
                            </adapt-see-more>
                        </div>
                    }
                }
            }
        </div>
    }
</ng-template>

<ng-template #teamTemplate
             let-team
             let-teamLocation="teamLocation">
    @if (team) {
        <adapt-team-card [team]="team"
                         [class.inactive-team]="!team.isActive()"
                         [teamLocation]="teamLocation"
                         [includeInactiveTeams]="showEndedTeams"
                         [filterTeams]="filterTeams"
                         [isEditing]="isEditing"
                         [showChildren]="true"
                         [currentViewLevel]="viewOption"
                         [teamContentTemplate]="teamContentTemplate"
                         [childrenExpanded]="(!viewOption || viewOption > 1) && teamHasChildren(team.teamId, showEndedTeams)">
        </adapt-team-card>
    }
</ng-template>

<ng-template #globalZoneLocationTemplate>
    <div *adaptLoadingUntilFirstEmit="let teams of globalZoneTeams$"
         class="p-2 global-zone"
         [class.is-editing]="isEditing"
         [class.can-drop]="draggingTeamCanBeDroppedIntoGlobalZone"
         [class.cannot-drop]="!draggingTeamCanBeDroppedIntoGlobalZone"
         [nxtSortablejs]="undefined"
         [config]="sortableOptions"
         data-location="zone-global">
        @for (team of teams; track team.teamId) {
            <adapt-team-card [team]="team"
                             [class.inactive-team]="!team.isActive()"
                             [includeInactiveTeams]="showEndedTeams"
                             [isEditing]="isEditing"
                             [showChildren]="true"
                             [currentViewLevel]="viewOption"
                             [teamContentTemplate]="teamContentTemplate"
                             [childrenExpanded]="(!viewOption || viewOption > 1) && teamHasChildren(team.teamId, showEndedTeams)"></adapt-team-card>
        }
    </div>
</ng-template>
